import ConditionalRequirement from './ConditionalRequirement'

const CustomName = translate => ConditionalRequirement('isCustomName', 'true', translate('customName'))

export default CustomName
